import {MeterType} from '@/data/models/enums/meter-enum';

export const ENUMS = {};

export const LIMIT_ROW_IMPORT = 600;

// Types masqués du dashboard (filtres par type et puces de sélection), et déclarables comme « compteur de référence » en administration.
// Demande Antoine : MeterType.CLIMATE_TEMPERATURE reste affiché sur le dashboard ; MeterType.CLIMATE_HUMIDITY et
// MeterType.CLIMATE_CO2 sont stockés et consultables en administration, mais ne sont pas affichés sur le dashboard.
export const REF_METER_TYPE = [
  MeterType.WIND, MeterType.LUX, MeterType.TEMPERATURE, MeterType.SANITARY_WATER, MeterType.CLOUD_FACTOR, MeterType.DEW_POINT, MeterType.CHILD, MeterType.CLIMATE_HUMIDITY,
  MeterType.CLIMATE_CO2
];
